import { takeLatest, put, call } from 'redux-saga/effects';
import {
    fetchUserStart,
    fetchUserSuccess,
    fetchUserFail,
    fetchProgressStart,
    fetchProgressSuccess,
    fetchProgressFail,
    fetchResultsStart,
    fetchResultsSuccess,
    fetchResultsFail,
    fetchUserAnswerListSuccess,
    fetchUserAnswerListFail,
    fetchUserAnswerListStart,
} from '../slices/userSlice';
import { getRequest } from '../../network';
import { USER_PROFILE, USER_PROGRESS, USER_RESULT, USER_ANSWERS } from '../apis';

// Fetch User Profile
function* fetchUserSaga(action) {
    try {
        const response = yield call(getRequest, `${USER_PROFILE}/${action.payload.userId}`);
        yield put(fetchUserSuccess(response));
    } catch (error) {
        yield put(fetchUserFail(error.message));
    }
}

// Fetch User Progress
function* fetchProgressSaga(action) {
    try {
        const response = yield call(getRequest, `${USER_PROGRESS}/${action.payload.userId}`);
        yield put(fetchProgressSuccess(response));
    } catch (error) {
        yield put(fetchProgressFail(error.message));
    }
}

function* fetchUserAnswers(action) {
    try {
        const response = yield call(getRequest, USER_ANSWERS);
        yield put(fetchUserAnswerListSuccess(response));
    } catch (error) {
        yield put(fetchUserAnswerListFail(error.message));
    }
}

// Fetch User Results
function* fetchResultsSaga(action) {
    try {
        const response = yield call(getRequest, `${USER_RESULT}/${action.payload.userId}`);
        yield put(fetchResultsSuccess(response));
    } catch (error) {
        yield put(fetchResultsFail(error.message));
    }
}

export function* watchUser() {
    yield takeLatest(fetchUserStart.type, fetchUserSaga);
    yield takeLatest(fetchProgressStart.type, fetchProgressSaga);
    yield takeLatest(fetchResultsStart.type, fetchResultsSaga);
    yield takeLatest(fetchUserAnswerListStart.type, fetchUserAnswers);
}